import { Widget } from '../widget/widget.js';

export class HiddenWidget extends Widget {
    async getValue(): Promise<any> {
        return this.$input.value;
    }
}

export class HiddenIntegerWidget extends Widget {
    async getValue(): Promise<any> {
        const { value } = this.$input;
        const num = parseInt(value);
        return Number.isNaN(Number(num)) ? 0 : num;
    }
}
